
import Vue, { PropType, VNode } from 'vue';
import Component from 'vue-class-component';

@Component({
	props: {
		level: {
			type: [Number, String] as PropType<number | string | null>,
			default: 2
		}
	}
})
export default class Heading extends Vue {
	protected readonly level!: number | null;

	protected get htag(): string {
		if (this.level === null) return 'div';
		if (typeof this.level === 'string') return this.level;
		return `h${this.level}`;
	}

	protected render(createElement: Function): VNode {
		return createElement(this.htag, this.$slots.default);
	}
}
